import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  ComboBox,
  Column,
  DataTable,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Button,
  Row,
  Pagination,  
  TableSelectRow,
  TableSelectAll,
  TableBatchAction,
  TableBatchActions,  
  Theme
} from '@carbon/react';
import { elegirDoc, getResoucesForViews, getListMailNameEmployeeByKey, postIdWithErrorCorrection } from '../../services/services';
import { ChangeCatalog } from '@carbon/icons-react';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";
import SessionController from '../../components/FrontSessionController/SessionController';
import MessageModal from "../../components/MessageModal/MessageModal";

const headers = [
  {
    key: 'flowtype',
    header: 'Form Type',
  },
  {
    key: 'firstApprover',
    header: 'First Approver (ID Error)',
  },
  {
    key: 'internalReference',
    header: 'Internal Reference',
  },
  {
    key: 'supplier',
    header: 'Supplier',
  },
  {
    key: 'createdDate',
    header: 'Created Date',
  },
  {
    key: 'information',
    header: 'General Information',
  }
];

const IdsWithError = () => {

  const EMPLOYEE_LIST_SEARCH_INPUT = [
    {
      mail: 'Please enter 4 or more characters',
      disabled: true

    }
  ]
  const EMPLOYEE_LIST_IS_EMPTY =
  [
    {
      mail: 'Not result found',
      disabled: true
    }
  ];

  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  
  const [lastCountryChosen, setLastCountryChosen] = useState();
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  

  const [approverSelected, setApproverSelected] = useState('');
  const [rowCountryApproverData, setRowCountryApproverData] = useState({});
  const [messageModal, setMessageModal] = useState("");
  const [messageSessionLost, setMessageSessionLost] = useState('');
  const [selectedRow, setSelectedRow] = useState({});
  const messageResponse = useRef([]); 
  const processingRequest = useRef(false);

  const [listEmployeesForUnique, setListEmployeesForUnique] = useState(EMPLOYEE_LIST_SEARCH_INPUT);  

  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);    
    messageResponse.current = [];
  }

  const processSelectEmployee = (e) => {
    let employeeSelected = "";
    if (e.selectedItem != undefined) {
      employeeSelected = e.selectedItem.mail;
    }
    setApproverSelected(employeeSelected);
  };

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      // Collect all arguments passed to the debounced function
      clearTimeout(timeout); // Clear any existing timeout
      timeout = setTimeout(() => {
        func.apply(this, args); // Execute the original function with the correct context and arguments
      }, delay);
    };
  }

  const getEmployeeList = (inputText) => {
    if (!isSearchInputForEmployeeValid(inputText)) return;
    inputText = inputText.toLowerCase();
    let request = {};
    request.clave = inputText;
    getListMailNameEmployeeByKey(request)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((response) => {
          processResponseForEmployeeSearch(response);
        });
      } else if (response.status === 410) {
        response.text().then((res) => {
          setMessageSessionLost(res);
        });
      }else if(response.status === 500){
        console.log(response.status);
        //do nothing
      }else{
        response.text()
          .then(response => {            
            openMessageModal(response);
          })
      }
    })
    .catch((error) => {
      console.log(error)
    });;
  };

  const isSearchInputForEmployeeValid = (inputText) => {        
    if(inputText === undefined || inputText.length < 4){      
      setListEmployeesForUnique(EMPLOYEE_LIST_SEARCH_INPUT);      
      return false;;
    }
    return true;
  }

  const processResponseForEmployeeSearch = (response) => {    
    setListEmployeesForUnique(EMPLOYEE_LIST_IS_EMPTY)
    if(response.length != 0){
      setListEmployeesForUnique(response);
    }    
  }

  const debouncedGetEmployeeList = debounce(getEmployeeList, 300);

  const isRequestActive = (enable) => {
    if (enable) {
      if (processingRequest.current) {
        openMessageModal("The request is processing");
        return true;
      }
      document.body.className = "waiting";
      processingRequest.current = enable;
      return false;
    } else {
      processingRequest.current = enable;
      document.body.className = "";
    }
    return false;
  };


  const actionChangeApproval = (action, selectedRow) => {
    switch (action) {
      case "open":
        setSelectedRow(selectedRow);
        setChangeApproverModal(true);
        break
      case "close":
        setSelectedRow({})
        setChangeApproverModal(false);
        break
      case "submit":
        submitChangeApproval()        
        break
      default:
        break
    }    
  }

  const submitChangeApproval = async () => {
    if(!fieldsAreValid()){
      return;
    }    
    if(isRequestActive(true)){
      return;
    } 
    let request = {};
    request.mail = approverSelected;
    request.ids = selectedRow[0].id;    
    await postIdWithErrorCorrection(request) 
    .then(response => {
      if(response.status === 200){       
        response.json()
        .then(response => {
          openMessageModal("Request Successful");
          parserResponseListAll(response);
        })   
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(res => {
            openMessageModal(res)                             
          })
      } 
    }) 
    actionChangeApproval('close');
    isRequestActive(false);    
  }

  const fieldsAreValid = () => {
    if(approverSelected.length === 0 || selectedRow[0].id.length === 0){
      openMessageModal("Fields can not be left empty")
      return false;
    }
    return true;
  }

  const goToDocumentForIdWithErrorView = (idDoc) => {      
    getDocumentForIdWithErrorView(idDoc);     
  };

  const getDocumentForIdWithErrorView = async (idDoc) => { 
    if(isRequestActive(true)){
      return;
    } 
    await elegirDoc(idDoc)
      .then(response => {
        if(response.status === 200){          
          if(response.status === 200) {
            console.log(200)           
          }
          navigate('/minimal-document-view');
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        }else{
          response.text()
            .then(res => {
              openMessageModal(res)                             
            })
        } 
      })                   
    isRequestActive(false);
  };

  
  const [firstApproverModal, setChangeApproverModal] = useState(false);  

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }  

  const goHomeScreen = () => {
    navigate("/home");
  };
  // When this Promise resolves, both values will be available.  

  const getIdsWithError1 = async (request) => {
    document.body.className = "waiting";
    await getResoucesForViews(request)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            parserResponseListAll(response);
          })
      } else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }  
    });    
    document.body.className = "";
  }

  const parserResponseListAll = (response) => {
    if(response != null) {
      const resParsedAll = response.map((res, i) => {
        const parsed = {};
  
        parsed["id"] = res.idDoc;
        parsed["idDoc"] = res.idDoc;
        parsed["flowtype"] = res.flow;
        parsed["internalReference"] = res.invonumb === "" ? res.invoiceNumb : res.invonumb;
        parsed["supplier"] = res.supplierName === "" ? res.suppname : res.supplierName;
        parsed["createdDate"] = res.gendocDate;
  
        return parsed;
  
      });
      setRows(resParsedAll);
      setAllRows(resParsedAll);
    } 
  }


  useEffect(() => {
    let request = {};
    request.viewName = 'IdsWithErrors';
    getIdsWithError1(request);    
  }, [0]);


  return (
    <>
      <Theme theme="g90">
        <CommodityHeader />
      </Theme>
       <TableContainer>
        <h2 className="table-title">ID's with error</h2>
        <Grid>
        <Modal
          className="addUniqueRange-modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Find Approver modal"
          modalAriaLabel="Find Approver modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={() => actionChangeApproval("close")}
          onRequestSubmit={() => actionChangeApproval("submit")}
          onSecondarySubmit={() => actionChangeApproval("close")}
          open={firstApproverModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Submit"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>Asterisks (<h5 className="asterisc">*</h5>) indicate fields required to complete this transaction.</strong></p>}
        >
          <Grid >
            <Column lg={16} >              
              <Row className="style-grid-modal-approver" >                
                <ComboBox
                  className="style-combo-approve"
                  onChange={(input) => {
                    processSelectEmployee(input);
                  }}
                  onInputChange={(inputText) =>
                    debouncedGetEmployeeList(
                      inputText
                    )
                  }
                  id="idComboBoxEmployeeToUnique"
                  placeholder="Search Approver"
                  key={'keyComboBoxEmployeeToUnique'}                  
                  items={listEmployeesForUnique}
                  titleText="Approver"
                  helperText=""
                  itemToString={(item) => (item ? item.mail : "")}
                />
              </Row>
            </Column>
            <Column lg={6}>
            </Column>
          </Grid>
        </Modal>
        </Grid>
        <Grid>
          <Column lg={16} >
          <Button className="style-bttbackID" size="lg" onClick={goHomeScreen}>
            Back to Home
          </Button>
            <DataTable
              isSortable="true"
              rows={rows}
              allRows={rows}
              headers={headers}
              render={({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getSelectionProps,
                getBatchActionProps,
                getTableProps,
                onInputChange,
                selectedRows
              }) => (
                <>
                  <TableContainer>
                   

                    {/* <p className="table-content-title"><strong>Click on a row to see more information.</strong></p> */}
                    <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                    {/* pass in `onInputChange` change here to make filtering work */}
                  </TableToolbarContent>

                  <TableBatchActions {...getBatchActionProps()}>
                    <TableBatchAction renderIcon={ChangeCatalog} iconDescription="Change First Approver"
                      onClick={() => { actionChangeApproval("open",selectedRows); getBatchActionProps().onCancel(); }}> Change First Approver
                    </TableBatchAction>
                  </TableBatchActions>
                </TableToolbar>
                    <Table {...getTableProps()} useZebraStyles>
                      <TableHead>
                        <TableRow>
                          <TableSelectAll {...getSelectionProps()} />

                          {headers.map(header => (
                            <TableHeader {...getHeaderProps({ header })}>

                              {header.header}
                            </TableHeader>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, rowNumb) => (
                          <TableRow {...getRowProps({ row })}>
                            <TableSelectRow  {...getSelectionProps({ row })} />

                            {row.cells.map((cell, i) => (
                              <>
                                {(i + 1 === row.cells.length) ? 
                                  <TableCell>
                                    <Button kind="ghost" size="sm" className="approve-button"
                                        onClick={() => goToDocumentForIdWithErrorView(row.id)} >
                                      More Information
                                    </Button>
                                  </TableCell> : 
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                }
                              </>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <Pagination
                      onChange={changePaginationState}

                      backwardText="Previous page"
                      forwardText="Next page"
                      itemsPerPageText="Items per page:"
                      page={page}
                      pageNumberText="Page Number"
                      pageSize={pageSize}
                      pageSizes={[
                        10,
                        25,
                        50,
                        100,
                      ]}
                      totalItems={rows.length}
                    />
                  </TableContainer>
                </>
              )}
            />
          </Column>
          <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
          <SessionController messageLostSessionCallback={messageSessionLost} />
        </Grid>
      </TableContainer>      
    </>
  );
};

export default IdsWithError;